import axios from 'helpers/axios'
// import axios from 'axios'
//  const baseURL = 'https://www.api.iv.myeasytransfer.com/V2'

// const axiosInstance = axios.create({
//   baseURL,
//   timeout: 20000,
// })


export const invoiceSherlockSecure = (token: string | undefined, body: any) =>
  axios
    .post(`/invoices/sherlockSecure`, body, {
      headers: {
        Authorization: token,
        accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

export const confirmPayment = (invoice_id: string | undefined, payementMode:string | undefined) =>
  axios
    .post(
      `/invoices/${payementMode}/confirmPayment`,
      { invoice_id },
      {
        headers: {
          accept: 'application/json',
        },
      },
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

    
export const historyinvoices = (
  userId: string | undefined, token: string | undefined,
   status:string, page:number, limit:number) =>
  axios
    .post(`/invoices/userInvoiceList`,
       
       {userId, status, page, limit},
      {headers: {
        Authorization: token,
        accept: 'application/json',
      }}
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

export const PaymentConfirmed = (body: any | undefined, token: string | undefined, paymentMode:string | undefined) =>
  axios
    .post(`/recharges/${paymentMode}/confirmPayment`, body, {
      headers: {
        Authorization: token,
        accept: 'application/json',
      },
    })
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })


    export const PaymentConfirmedCarte = (body: any | undefined) =>
  axios
    .post(`/pcs/confirmPayment`, body,
      //  {
      // headers: {
      //   Authorization: token,
      //   accept: 'application/json',
      // },    }
    )
    .then((response) => {
      return response?.data
    })
    .catch((error) => {
      console.log(error)
    })

  export const ConfirmpaymentRecharge = async (body: any)=>
     { try{
        const response= await axios.post(`/recharges/volume/confirmPayment`, body, 
        //  { headers:{
        //     Authorization: token,
        //   Accept: 'application/json' 
        // }}
      )
        return response.data
      }catch(error){
        console.error(error)
        throw (error)
      }
    }

  export const ConfirmpaymentInvoices = async (body: any)=>{
    try {
      const response= await axios.post(`/invoices/volume/confirmPayment`, body ,
        // {headers: {
        //   Authorization: token,
        //   Accept: 'application/json'
        // }}
      )
      return response.data
    }catch(error){
      console.log(error)
      throw(error)
    }
  }